import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";


@Entity('grade_suggestion')
export class GradeSuggestion {

    @PrimaryGeneratedColumn("increment",{name:'grade_suggestion_id'})
    gradeSuggestionId:number;
  
    @Column("int",{
        nullable:false,
      //   length:20,
        name:"min_grade"
        })
    minGrade:number;

    @Column("int",{
      nullable:false,
    //   length:10,
      name:"max_grade"
      })
    maxGrade:number;

    @Column("int",{
      nullable:false,
      name:"product_id"
      })
    productId:number;
    
    @Column("int",{
      nullable:true,
      name:"saleOrder_id"
      })
    saleOrderId:number;
    @Column("int",{
      nullable:false,
      name:"priority"
      })
    priority:number;
    @Column("int",{
      nullable:false,
      name:"planned_qty"
      })
    plannedQuantity:number;
   @Column("date",{
     nullable:true,
     name:"date"
      })
    date:Date;
    @Column("int",{
    nullable:false,
    name:"plant_id"
      })
    plantId:number;
    @Column("int", {
      nullable: true,
      name: "sequence"
    })
    sequence: number;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  
}
